function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

if (!customElements.get('product-form-quickview')) {
  customElements.define('product-form-quickview', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (this.form != null) {
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
            window.location = window.routes.cart_url;
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

class QuickModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden-modal');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocusInModal(this);
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    cancelTrappedFocusInModal(this);
  }
}
customElements.define('quick-modal-dialog', QuickModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal',
    class QuickAddModal extends QuickModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');

        var product_url = opener.getAttribute('data-product-url');
        fetch(product_url)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('[id^="MainProduct-"]');
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            setPatternSwatches();

            setTimeout(() => {
              const bannerSlideElement = this.modalContent.querySelector('.swiper-container.banner-slide');
              const thumbnailsElement = this.modalContent.querySelector('.swiper-container.thumbnails');
              const bannerSlideSwiperInitValue = bannerSlideElement.getAttribute('data-swiper-init');
              const swatchesSwiper = this.modalContent.querySelector('.swiper-container.product-swatches');
              if (swatchesSwiper){
                const swatchesSwiperInitValue = swatchesSwiper.getAttribute('data-swiper-init');
                window.swiperOptions = window.swiperOptions || {};
                window.swiperOptions[swatchesSwiperInitValue] = {
                  slidesPerView: 7,
                  slidesPerGroup: 7,
                  spaceBetween: 6,
                  grid: {
                    rows: 2,
                    fill: "row",
                  },
                  navigation: {
                    nextEl: "#swiper-" + swatchesSwiperInitValue + " .swiper-button-next-swatch",
                    prevEl: "#swiper-" + swatchesSwiperInitValue + " .swiper-button-prev-swatch",
                  },
                  pagination: {
                    el: '#swiper-' + swatchesSwiperInitValue + ' .product-carousel__pagination',
                    type: 'bullets',
                    clickable: true,
                    bulletClass: 'product-carousel__pagination-bullet'
                  }
                };
                new Swiper(swatchesSwiper, window.swiperOptions[swatchesSwiperInitValue]);
              }

              this.mainMediaSwiper = createMainMediaSwiper();
              this.thumbnailSwiper = createThumbnailSwiper();

              class VariantSelects extends HTMLElement {
                constructor() {
                  super();
                  this.addEventListener('change', this.onVariantChange);
                }

                onVariantChange() {
                  if (this.mainMediaSwiper) {
                    this.mainMediaSwiper.destroy(true, true);
                  }

                  if (this.thumbnailSwiper) {
                    this.thumbnailSwiper.destroy(true, true);
                  }


                  this.mainMediaSwiper = createMainMediaSwiper();
                  this.thumbnailSwiper = createThumbnailSwiper();

                  this.updateOptions();
                  this.updateMasterId();
                  this.removeErrorMessage();
                  this.updateVariantStatuses();
                  this.updateVariantContent()
                  if (!this.currentVariant) {
                    this.setUnavailable();
                  } else {
                    this.updateURL();
                    this.filterMedia();
                    this.updateVariantInput();
                    this.renderProductInfo();
                  }
                }

                filterMedia() {
                  let selected_variant = this.currentVariant.featured_media.alt;
                  let selected_attribute = '[thumbnail-color="' + selected_variant + '"]';
                  let all_variants = '[thumbnail-color="All Variants"]';

                  // Hide all elements first
                  document.querySelectorAll('[thumbnail-color]').forEach(function (el) {
                    el.style.display = 'none';
                  });

                  if (selected_variant == selected_variant) {
                    // Get all the elements to reposition in an array
                    let elementsToReposition = Array.from(document.querySelectorAll(selected_attribute));

                    // Reverse the array to keep the original order when repositioning
                    elementsToReposition.reverse().forEach(function (el) {
                      el.style.display = 'block';

                      // Get parent of the element
                      let parent = el.parentNode;

                      // Remove the element from its current position
                      parent.removeChild(el);

                      // Append the element as the first child of its parent
                      parent.insertBefore(el, parent.firstChild);
                    });
                  }

                  // Show all variants
                  document.querySelectorAll(all_variants).forEach(function (el) {
                    el.style.display = 'block';
                  });
                }
                updateVariantContent() {

                }

                updateOptions() {
                  this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
                }

                updateMasterId() {
                  this.currentVariant = this.getVariantData().find((variant) => {
                    return !variant.options
                      .map((option, index) => {
                        return this.options[index] === option;
                      })
                      .includes(false);
                  });
                }
                updateURL() {
                  if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
                  window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
                }

                updateVariantInput() {
                  const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}`);
                  productForms.forEach((productForm) => {
                    const input = productForm.querySelector('input[name="id"]');
                    input.value = this.currentVariant.id;
                    input.dispatchEvent(new Event('change', { bubbles: true }));
                  });
                }

                updateVariantStatuses() {
                  const selectedOptionOneVariants = this.variantData.filter(
                    (variant) => this.querySelector(':checked').value === variant.option1
                  );
                  const inputWrappers = [...this.querySelectorAll('.product-form__input')];
                  inputWrappers.forEach((option, index) => {
                    if (index === 0) return;
                    const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
                    const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
                    const availableOptionInputsValue = selectedOptionOneVariants
                      .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
                      .map((variantOption) => variantOption[`option${index + 1}`]);
                  });
                }

                removeErrorMessage() {
                  const section = this.closest('section');
                  if (!section) return;

                  const productForm = section.querySelector('product-form');
                  if (productForm) productForm.handleErrorMessage();
                }

                renderProductInfo() {
                  const requestedVariantId = this.currentVariant.id;
                  const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

                  fetch(
                    `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
                    }`
                  )
                    .then((response) => response.text())
                    .then((responseText) => {
                      // prevent unnecessary ui changes from abandoned selections
                      if (this.currentVariant.id !== requestedVariantId) return;

                      const html = new DOMParser().parseFromString(responseText, 'text/html');
                      const destination = document.getElementById(`price-${this.dataset.section}`);
                      const source = html.getElementById(
                        `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                      );
                      const skuSource = html.getElementById(
                        `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                      );
                      const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
                      const inventorySource = html.getElementById(
                        `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                      );
                      const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

                      if (source && destination) destination.innerHTML = source.innerHTML;
                      if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
                      if (skuSource && skuDestination) {
                        skuDestination.innerHTML = skuSource.innerHTML;
                        skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
                      }

                      const price = document.getElementById(`price-${this.dataset.section}`);

                      if (price) price.classList.remove('visibility-hidden');

                      if (inventoryDestination)
                        inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');



                      publish(PUB_SUB_EVENTS.variantChange, {
                        data: {
                          sectionId,
                          html,
                          variant: this.currentVariant,
                        },
                      });
                    });
                }

                toggleAddButton(disable = true, text, modifyClass = true) {
                  const productForm = document.getElementById(`product-form-${this.dataset.section}`);
                  if (!productForm) return;
                  const addButton = productForm.querySelector('[name="add"]');
                  const addButtonText = productForm.querySelector('[name="add"] > span');
                  if (!addButton) return;

                  if (disable) {
                    addButton.setAttribute('disabled', 'disabled');
                    if (text) addButtonText.textContent = text;
                  } else {
                    addButton.removeAttribute('disabled');
                    addButtonText.textContent = window.variantStrings.addToCart;
                  }

                  if (!modifyClass) return;
                }

                setUnavailable() {
                  const button = document.getElementById(`product-form-${this.dataset.section}`);
                  const addButton = button.querySelector('[name="add"]');
                  const addButtonText = button.querySelector('[name="add"] > span');
                  const price = document.getElementById(`price-${this.dataset.section}`);
                  const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
                  const sku = document.getElementById(`Sku-${this.dataset.section}`);

                  if (!addButton) return;
                  addButtonText.textContent = window.variantStrings.unavailable;
                  if (price) price.classList.add('visibility-hidden');
                  if (inventory) inventory.classList.add('visibility-hidden');
                  if (sku) sku.classList.add('visibility-hidden');
                }

                getVariantData() {
                  console.log(this)
                  console.log('test')
                  this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent).variant;
                  console.log(this.variantData)
                  return this.variantData;
                }
                getVariantMetafieldData() {
                  this.variantMetafieldData = this.variantMetafieldData || JSON.parse(this.querySelector('[type="application/json"]').textContent).metafields;
                  console.log(this.variantMetafieldData)
                  return this.variantMetafieldData;
                }
              }
customElements.get('variant-selects') || customElements.define('variant-selects', VariantSelects);
              class VariantRadios extends VariantSelects {
                constructor() {
                  super();
                }

                updateOptions() {
                  const fieldsets = Array.from(this.querySelectorAll('fieldset'));
                  this.options = fieldsets.map((fieldset) => {
                    return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
                  });
                }
              }
customElements.get('variant-radios') || customElements.define('variant-radios', VariantRadios);
              /***** Product Variants JS end *****/
            }, 250);



            super.show(opener);

            var
              update_variants = this.querySelector('.product-form__input'),
              cart_variant = this.querySelector('.product-form input[name="id"]'),
              quantity = this.querySelector('.quantity__input'),
              current_variant,
              current_quantity = 1,
              previous_variant = this.getAttribute('current-variant'),
              variant_price = this.querySelector('.regular-price'),
              variant_cp = this.querySelector('.compare-price s');

            if (update_variants !== null) {
              var selected_variant = update_variants.querySelector('input').getAttribute('variant-id');
            }

            if (cart_variant != null) {
              //cart_variant.value = selected_variant;
            }
            current_variant = selected_variant;
            if (quantity != null) {
              quantity.addEventListener('change', function (e) {
                current_quantity = quantity.value;
              });
            }
            if (update_variants !== null) {
              update_variants.addEventListener('change', function (e) {
                var selected_variant = e.target.getAttribute('variant-id');
                var selected_variant_price = e.target.getAttribute('variant-price');
                var selected_variant_cp = e.target.getAttribute('variant-cp');

                if (cart_variant != null) {
                  cart_variant.value = selected_variant;
                }
                current_variant = selected_variant;
                if (variant_cp != null) {
                  variant_price.innerHTML = selected_variant_price;
                }
                if (variant_cp != null) {
                  variant_cp.innerHTML = selected_variant_cp;
                }
              })
            }
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }
    }
  );
}
